// src/shared/ui/Select.jsx — promoted from adai/components/ui/Select.jsx
//
// options is normally a flat [{value, label, disabled?}] list. An entry may
// instead be a group -- {label, options: [{value, label, disabled?}, ...]}
// (no `value` of its own) -- rendered as a native <optgroup>. The two forms
// can be mixed in one array.
import { forwardRef } from "react";
import { ChevronDown } from "lucide-react";
import "./formControls.css";

function renderOption(opt) {
  return (
    <option key={opt.value} value={opt.value} disabled={opt.disabled}>
      {opt.label}
    </option>
  );
}

const Select = forwardRef(({ options, className = "", ...props }, ref) => (
  <div className="relative w-full">
    <select ref={ref} {...props} className={`shui-input adai-form-input appearance-none cursor-pointer pr-12 ${className}`.trim()}>
      {options.map((opt) =>
        opt.options ? (
          <optgroup key={opt.label} label={opt.label}>
            {opt.options.map(renderOption)}
          </optgroup>
        ) : (
          renderOption(opt)
        )
      )}
    </select>
    <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
      <ChevronDown size={18} className="text-slate-400" />
    </div>
  </div>
));

Select.displayName = "Select";

export default Select;
